__webpack_require__.p = "https://assets.khanoumi.com/4.170.1.0/_next/";